const API_URL = import.meta.env.VITE_API_URL || `${window.location.origin}/api`;

function getUserInfo() {
  try {
    const raw = localStorage.getItem("futureOfTV_User");
    if (raw) {
      const u = JSON.parse(raw);
      return { userId: u.id || u._id, userEmail: u.email };
    }
  } catch { /* ignore */ }
  return {};
}

let recentReports = [];

export function reportCrash({ error, componentStack, source = "manual", extra } = {}) {
  const errorStr = error instanceof Error
    ? `${error.name}: ${error.message}`
    : String(error || "Unknown error");

  const dedupeKey = `${errorStr}|${source}`;
  const now = Date.now();
  recentReports = recentReports.filter((r) => now - r.ts < 10000);
  if (recentReports.some((r) => r.key === dedupeKey)) return;
  recentReports.push({ key: dedupeKey, ts: now });

  const payload = {
    error: errorStr,
    componentStack: componentStack || undefined,
    url: window.location.href,
    userAgent: navigator.userAgent,
    source,
    extra,
    ...getUserInfo(),
  };

  fetch(`${API_URL}/crash-reports`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}

export function installGlobalHandlers() {
  window.addEventListener("error", (event) => {
    reportCrash({
      error: event.error || event.message,
      source: "unhandled-error",
      extra: { filename: event.filename, lineno: event.lineno, colno: event.colno },
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    reportCrash({
      error: event.reason,
      source: "unhandled-rejection",
      extra: {
        fullStack: (event.reason?.stack || "").slice(0, 2000),
      },
    });
  });
}
